export enum ContentTypeFieldType {
  TEXT = 'Text',
  FILE = 'File',
  DATE_TIME = 'DateTime',
  TAXONOMY_FIELD_TYPE_MULTI = 'TaxonomyFieldTypeMulti',
  TAXONOMY_FIELD_TYPE = 'TaxonomyFieldType',
  NOTE = 'Note',
}
